import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const HeroBtn = styled('div')`
  margin-bottom: ${fromTheme('spacing_small')};
`;

export const HeroImage = styled.div<{
  imageUrl: string;
  enhancementEnabled?: boolean;
}>`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url('${({ imageUrl }) => imageUrl}');

  @media (min-width: ${fromTheme('screen_medium')}) {
    background-image: url('${({ imageUrl }) => imageUrl}');
  }

  border-radius: ${({ enhancementEnabled, ...rest }) =>
    enhancementEnabled ? fromTheme('border_radius_medium')(rest) : 'unset'};
`;
